<template>
  <iframe
    src="/routevision/"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
export default {
  name: 'RouteVision'
}
</script>

<style scoped>
iframe {
  border-width: 0;
}
</style>
